import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Spinner } from 'react-bootstrap'
import { ClipLoader } from 'react-spinners';
import { fetchEvents } from '../../actions'
import classnames from 'classnames'

function CalendarListing(props){
  const { listing, toggleCalendarVisibility, fetchEvents, visibleCalendars, organization, current_user, calendars, visible, filter, canEdit } = props
  const [ toggled, setToggled ] = useState(true)

  useEffect(() => {
    $.ajax({
      url: `/organizations/${organization.name}/users/${current_user.id}.json`,
      method: 'PATCH',
      data: { 
        user: {
          settings: {
            visible_calendars: visibleCalendars.length > 0 ? visibleCalendars : [''] //ids of visible calendars
          }
        } 
      }
    })
  }, [listing.visible]);

  useEffect(() => {
    if(listing.visible){
      fetchEvents({
        resident_id: listing.resident_id,
        owner: listing.owner, 
        calendar: listing.id, 
        startDate: filter.startDate ? moment(filter.startDate).startOf("day").format("YYYY-MM-DD") : moment().startOf("month").startOf("week").format("YYYY-MM-DD"),
        endDate: filter.endDate ? moment(filter.endDate).endOf("day").format("YYYY-MM-DDTHH:mm") : moment().endOf("month").endOf("week").format("YYYY-MM-DDTHH:mm")
      })
    }
  }, [listing.visible, filter]);

  function handleToggleVisibility(){
    toggleCalendarVisibility(listing)
  }

  return(
    <div className={classnames("unselectable", "align-items-center", "pt-1", "pb-2", "justify-content-between", {"d-none": !visible, "d-flex": visible})} style={{cursor: 'pointer'}}>
      <div onClick={ () => handleToggleVisibility() } className="d-flex align-items-center">
        {
          listing.isLoading ?
          <ClipLoader
            sizeUnit={"px"}
            size={12}
            color={listing.color}
            loading={true}/> :
          <Checkbox 
            toggled={listing.visible} 
            color={listing.color}/>
        }
        <span className="font-weight-light ml-2" style={{fontWeight: '400'}}>{listing.name}</span>
      </div>
      <div>
        { listing.editableByCurrentUser && canEdit && <a href={`calendars/${listing.id}/edit`} style={{ textDecorationLine: 'none', color: listing.color }} className="fas fa-cog"/> }
        <a className="fas fa-eye-dropper ml-2" href={`calendars/${listing.id}/settings/edit`} style={{color: listing.color, textDecorationLine: 'none'}}/>
      </div>
    </div>
  )
}

function Checkbox(props){
  return(
    <div style={{border: `2px solid ${props.color}`, height: '12px', width: '12px', borderRadius: 6, backgroundColor: (props.toggled && props.color)}} className={'d-inline-block'}/>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    organization: state.organization,
    current_user: state.current_user,
    visibleCalendars: state.calendars.filter(calendar=>calendar.visible).map(calendar=>calendar.id),
    calendars: state.calendars,
    filter: state.filter,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleCalendarVisibility: ( calendar ) => dispatch({ type: "TOGGLE_CALENDAR_VISIBILITY", payload: { calendar } }),
    fetchEvents: (obj) => dispatch(fetchEvents(obj)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarListing);

